import React, { useContext } from 'react';
import { Navigate } from 'react-router-dom';
import { LoginContext } from '../Contexts/LoginContext';
import BuyerLayout from '../Layouts/BuyerLayout';
import { showToast } from "../Components/utils/ShowToast";
import SEO from '../Components/utils/SEO';

const ProtectedRoute = ({ children, isFooter = true }) => {
    const { isLogin, isProfileIncomplete } = useContext(LoginContext);

    if (isLogin === null)
        return null;

    if (!isLogin) {
        showToast("Please login to access that Resource!", "info")
        return <Navigate to="/signin" replace />;
    }

    if (isProfileIncomplete) {
        showToast("Please complete your profile first!", "info");
        return <Navigate to="/completeProfile" replace />;
    }

    return (
        <>
            <SEO title="Account" description="Chocowi account area" noIndex noFollow />
            <BuyerLayout isFooter={isFooter}>{children}</BuyerLayout>
        </>
    );
};

export default ProtectedRoute;